import styled from 'styled-components';
import { colors } from '@chegg-ui/theme';
var greyLight = colors.greyLight;
export var Divider = styled.hr.withConfig({
  componentId: "sc-hb4dz2-0"
})(["border:none;border-top:2px solid ", ";height:1px;margin:20px 0;"], greyLight);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/components/DropInPayments/styled.js
// module id = 4661
// module chunks = 11